import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from '../../config/config';
import Swal from 'sweetalert2';
@Injectable()
export class CargaCuentasExcel {
  private errors: any[];
  constructor(private ctaService: CtbCtaService) {
  }
  public async realizarCargaConArrayExcel(array: any[], estructura: string, gral_emp_id: number
    , gral_suc_id: number, gral_usr_crea_id: number) {
    if (array.length === 0) {
      this.mostrarMensajeError('El formato no tiene registros');
    } else {
      const cuentas_padre = [];
      let indice_cuenta_titulo = 0, indice_cuenta_subtitulo = 0, indice_cuenta_acumulable = 0;
      // Preparar los campos de cuenta para su analisis
      array = this.prepararListaCuentasParaAnalisis(array, gral_emp_id, gral_suc_id, gral_usr_crea_id);
      // Verificar si se especifican las cuentas padre
      const cuentas_padres_presentes = this.validarCuentasPadrePresentes(array);
      Swal.fire({
        icon: 'info',
        title: 'Mensaje',
        confirmButtonText: 'Continuar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: 'red',
        text: 'El sistema puede automatizar la asignación de cuentas padres en una estructura de como maximo 4 niveles. Si ya verificó la estructura presione "Continuar"'
      }).then((result) => {
        if (result.value) {
          let estatus_correcto = true;
          for (let x = 0; x < array.length && estatus_correcto === true; x++) {
            const registro = array[x];
            if(registro.CUENTA_PADRE !== undefined){
            registro.CUENTA_PADRE = String(registro.CUENTA_PADRE);
            }
            registro.CUENTA = String(registro.CUENTA);
            // Valida sí los digitos de la cuenta son los mismos qué los de la estructura registrada
            estatus_correcto = this.validarDigitosCuenta(x, estructura, registro.CUENTA);
            // Valida el tipo de cuenta
            estatus_correcto = this.validarTipoCuenta(x, registro.TIPO);
            // Valida la naturaleza de las cuentas
            estatus_correcto = this.validarNaturalezaCuenta(x, registro.NATURALEZA);
            // Valida la clasificación de las cuentas
            estatus_correcto = this.validarClasificacionCuenta(x, registro.CLASIFICACION);
            // Valida la cuenta padre
            if (registro.CUENTA_PADRE != null && registro.CUENTA_PADRE !== '' && registro.CUENTA_PADRE !== undefined) {
              
              estatus_correcto = this.validarCuentaPadre(x, registro.CLASIFICACION, registro.CUENTA_PADRE, cuentas_padre);
              
              if(estatus_correcto === true){
                for (let y = 0; y < array.length; y++) {
                  if (String(array[y].CUENTA) === String(registro.CUENTA_PADRE)) {
                    registro.cuenta_padre_indice = y;
                    console.log('Match confirmado');
                    break;
                  }
                }
              }
            } else {
              /** En caso de no haber especificado ninguna cuenta padre,
              sé intenta asignar la cuenta padre tomando como referencia la clasificación y el orden **/
              if (cuentas_padres_presentes === false) {
                switch (registro.CLASIFICACION.toLowerCase()) {
                  case 'titulo':
                    indice_cuenta_titulo = x;
                    indice_cuenta_subtitulo = 0;
                    break;
                  case 'subtitulo':
                    registro.cuenta_padre_indice = indice_cuenta_titulo;
                    indice_cuenta_subtitulo = x;
                    break;
                  case 'acumulable':
                    if (indice_cuenta_subtitulo !== 0) {
                      registro.cuenta_padre_indice = indice_cuenta_subtitulo;
                    } else {
                      registro.cuenta_padre_indice = indice_cuenta_titulo;
                    }
                    indice_cuenta_acumulable = x;
                    break;
                  case 'afectable':
                    registro.cuenta_padre_indice = indice_cuenta_acumulable;
                    break;
                }
              } else {
                
                // En caso de haber especificado cuentas padres, se recorre y ubica respecto a lo insertado en la variable cuentas_padre
                for (let y = 0; y < cuentas_padre.length; y++) {
                  if (cuentas_padre[y] === registro.CUENTA) {
                    registro.cuenta_padre_indice = y;
                    break;
                  }
                }
              }
              
            }
            cuentas_padre.push(String(registro.CUENTA));
            array.splice(x, 1, registro);
          }
          // Verificar integridad de referencia a cuentas padre
          if (estatus_correcto) {
            estatus_correcto = this.validarIntegridadReferenciaCuentasPadre(cuentas_padres_presentes, array);
          }
          for (let x = 0; x < array.length; x++) {
            array[x].CUENTA = this.asignarEstructura(array[x].CUENTA, estructura);
          }
          if (estatus_correcto) {
            this.cargarCuentas(array);
          }
        } else {
          window.location.reload();
        }
      });
    }
  }

  private validarCuentasPadrePresentes(array: any[]) {
    for (let x = 0; x < array.length; x++) {
      if (array[x].CUENTA_PADRE != null && array[x].CUENTA_PADRE !== '' && array[x].CUENTA_PADRE !== undefined) {
        array[x].CUENTA_PADRE = String(array[x].CUENTA_PADRE).split(' ').join('');
        return true;
      }
    }
    return false;
  }
  private prepararListaCuentasParaAnalisis(array: any[], gral_emp_id: number, gral_suc_id: number, gral_usr_crea_id: number) {
    for (let x = 0; x < array.length; x++) {
      array[x].CUENTA = String(array[x].CUENTA).split(' ').join('');
      array[x].CUENTA = String(array[x].CUENTA).split('-').join('');
      array[x].NATURALEZA = String(array[x].NATURALEZA).split(' ').join('');
      array[x].CLASIFICACION = String(array[x].CLASIFICACION).split(' ').join('');
      array[x].MONEDA = String(array[x].MONEDA).split(' ').join('');
      array[x].gral_emp_id = gral_emp_id;
      array[x].gral_suc_id = gral_suc_id;
      array[x].gral_usr_crea_id = gral_usr_crea_id;
    }
    return array;
  }

  // Valida sí los digitos de la cuenta son los mismos qué los de la estructura registrada
  private validarDigitosCuenta(indice: number, estructura: string, cuenta: string) {
    if (estructura.split('-').join('').length !== cuenta.length) {
      this.mostrarMensajeError('El numero de cuenta "' + cuenta + '" presente en la fila "' + (indice + 2) + '" tiene ' +
        (estructura.split('-').join('').length > cuenta.length ? 'menos' : 'mas') +
        ' digitos qué los permitidos por la estructura de cuentas configurada');
      return false;
    }
    return true;
  }

  // Valida el tipo de cuenta
  private validarTipoCuenta(indice: number, tipo: string) {
    const tipos = ['Activo', 'Pasivo', 'Capital contable', 'Ingresos', 'Costos', 'Gastos', 'Resultado integral de financiamiento', 'Cuentas de orden'];
    if (this.verificarSiArrayContieneSubString(tipos, tipo) === false) {
      this.mostrarMensajeError('El tipo de cuenta "' + tipo + '" presente en la fila "' + (indice + 2) + '" es invalido');
      return false;
    }
    return true;
  }
  // Valida la naturaleza de las cuentas
  private validarNaturalezaCuenta(indice: number, naturaleza: string) {
    const naturalezas = ['Deudora', 'Acreedora'];
    if (this.verificarSiArrayContieneSubString(naturalezas, naturaleza) === false) {
      this.mostrarMensajeError('La naturaleza de cuenta "' + naturaleza +
        '" presente en la fila "' + (indice + 2) + '" es invalida');
      return false;
    }
    return true;
  }

  // Valida la clasificación de las cuentas
  private validarClasificacionCuenta(indice: number, clasificacion: string) {
    const clasificaciones = ['Titulo', 'Subtitulo', 'Acumulable', 'Afectable'];
    if (this.verificarSiArrayContieneSubString(clasificaciones, clasificacion) === false) {
      this.mostrarMensajeError('La clasificación de cuenta "' + clasificacion + '" presente en la fila "' + (indice + 2) + '" es invalida');
      return false;
    }
    return true;
  }

  // Valida la cuenta padre
  private validarCuentaPadre(indice: number, clasificacion: string, cuenta_padre: string, cuentas_padre: string[]) {
    if (clasificacion === 'Titulo') {
      this.mostrarMensajeError('La cuenta de titulo no puede tener cuentas padres');
      return false;
    }
    if (this.verificarSiArrayContieneSubString(cuentas_padre, cuenta_padre) === false) {
      this.mostrarMensajeError('La cuenta padre "' + cuenta_padre + '" presente en la fila "' + (indice + 2) + '" no forma parte de ningun registro');
      return false;
    }
    return true;
  }

  // Verificar integridad de referencia a cuentas padre
  private validarIntegridadReferenciaCuentasPadre(cuentas_padres_presentes: boolean, array: any[]) {
    for (let x = 0; x < array.length; x++) {
      if (cuentas_padres_presentes === false && ((array[x].CLASIFICACION.toLowerCase() !== 'titulo' &&
        (array[x].cuenta_padre_indice === null || array[x].cuenta_padre_indice === undefined))
        || x < array[x].cuenta_padre_indice)) {
        this.mostrarMensajeError('La estructura de cuentas de su catalogo de cuentas no es compatible con el algoritmo de auto-asignación de cuentas padre, considere especificar las cuentas padre en el campo "CUENTA PADRE"');
        return false;
      } else if (cuentas_padres_presentes === true && ((array[x].CLASIFICACION.toLowerCase() !== 'titulo' &&
        (array[x].cuenta_padre_indice === null || array[x].cuenta_padre_indice === undefined))
        || x < array[x].cuenta_padre_indice
        )) {
        this.mostrarMensajeError('La cuenta ' + array[x].CUENTA + ' presente en la fila ' + (x + 2));
        return false;
      }
    }
    return true;
  }

  private asignarEstructura(cuenta: string, estructura: string): string {
    let cuenta_formateada = estructura;
    for (let x = 0; x < cuenta.length; x++) {
      cuenta_formateada = cuenta_formateada.replace('X', cuenta[x]);
    }
    return cuenta_formateada;
  }

  private verificarSiArrayContieneSubString(array: string[], substring: string) {
    const index = array.findIndex(element => {
      substring = String(substring);
      if (element.split(' ').join('').toLowerCase().includes((substring.split(' ').join('')).toLowerCase())) {
        return true;
      }
    });
    if (index !== -1) {
      return true;
    }
    return false;
  }

  private cargarCuentas(cuentas: any[]) {
    this.ctaService.postCarga(cuentas).subscribe(
      response => {
        this.mostrarMensajeSuccess(response.mensaje);
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        this.errors = err.error.error;
          this.mostrarMensajeError(err.error.mensaje);
      }
    );
  }
    private mostrarMensajeSuccess(mensaje: string) {
      Swal.fire({
        icon: 'success',
        title: 'Mensaje',
        allowOutsideClick: false,
        text: mensaje = ! null ? mensaje : 'Ha ocurrido un error'
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
      });
    }

  private mostrarMensajeError(mensaje: string) {
    Swal.fire({
      icon: 'error',
      title: 'Mensaje',
      allowOutsideClick: false,
      text: mensaje = ! null ? mensaje : 'Ha ocurrido un error'
    }).then((result) => {
      if (result.value) {
        window.location.reload();
      }
    });
  }
}

@Injectable({
  providedIn: 'root'
})
export class CtbCtaService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {

  }

  getMon(): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/moneda';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_);
  }
  instalarCatalogo(gral_emp_id: number, gral_usr_id: number, catalogo: string): Observable<any> {
    let url_ = this.dataUrl + '/cta/instalarCatalogo/'+ gral_emp_id + '/' + gral_usr_id + '/' + catalogo;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, null);
  }
  getEmp(id: number): Observable<any> {
    let url_ = this.dataUrl + '/gral_emp/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_);
  }

  getMonByEmpId(id: number): Observable<any> {
    let url_ = this.dataUrl + '/gralmon/get/byEmp/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getTipo(): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/tipo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_);
  }
  getSat(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/sat';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postTpol(dto: CtbCtaDto): Observable<any> {
    let url_ = this.dataUrl + '/cta/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postCarga(lista: any[]): Observable<any> {
    let url_ = this.dataUrl + '/cta/post/cargarCuentas';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, lista).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  putTpol(dto: CtbCtaDto): Observable<any> {
    let url_ = this.dataUrl + '/cta/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  actualizarCc(CtbCtaId: number, CtbCcId: number,GralUsrId: number): Observable<any> {
    let url_ = this.dataUrl + '/cta/relacionarCC/'+CtbCtaId+'/'+ CtbCcId +'/' + GralUsrId;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, null).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  deleteTpol(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/cta/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getReporteAuxCtaXml(idEmp: number, mes: number, anio: number, tipoEnvio: string, num: string): Observable<any> {
    const url_ = this.dataUrl
    + '/repauxmov/get/reporte/auxiliar/xml/' + idEmp + '/' + mes + '/' + anio + '/' + tipoEnvio + '/' + num;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getReporteAuxFolXml(idEmp: number, mes: number, anio: number, tipoEnvio: string, num: string): Observable<any> {
    const url_ = this.dataUrl
    + '/pol/get/reporte/auxiliar/folios/xml/' + idEmp + '/' + mes + '/' + anio + '/' + tipoEnvio + '/' + num;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  ctaCatalogo(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/cta/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

 
  getCta(id: number): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postReporte(criteria: any): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/reporte';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criteria).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getReporte(gral_emp_id: number, registros: number): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/reporte/' + gral_emp_id + '/' + registros;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getReporteXml(gral_emp_id: number, registros: number): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/reporte/xml/' + gral_emp_id + '/' + registros;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_,  {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getReporteXlsx(gral_emp_id: number, registros: number): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/reporte/xlsx/' + gral_emp_id + '/' + registros;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_,  {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getReportePdf(gral_emp_id: number, registros: number): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/reporte/pdf/' + gral_emp_id + '/' + registros;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_, {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}

export class CtbCtaDto {
  id: number;
  cuenta: string;
  nombre: string;
  cuentaPadre: CtbCtaDto;
  req_cc: boolean | undefined = false;
  estatus: boolean | undefined = true;
  ctb_may_clases_id: number;
  naturaleza: number |  undefined = 1;
  nivel: number | undefined = 1;
  clasificacion: number | undefined = 1;
  tipo: number | undefined = 1;
  gralMonId: number | undefined = 1;
  gralEmpId: number;
  gralSucId: number;
  ctbCC: any|undefined = {id:0, titulo:'Por definir', codigo:''};
  gralUsrCreaId: number;
  ctb_cc_id: number;
  gralUsrActualizaId: number;
  gralUsrBajaId: number;
  momento_crea: string;
  mmomento_actualiza: string;
  mmomento_baja: string;
  satCtaCtb: SatCtaCtbDto | undefined = new SatCtaCtbDto();
}
export class CtbTipoDto {
  id: number;
  titulo: string;
}
export class GralMonDto {
  id: number;
  simbolo: string;
}
export class SatCtaCtbDto {
  id: number;
  clave: string;
  descripcion: string;
}

export class PageBusquedaObject {
  column?: string | undefined = '';
  criteriaSearch?: any | undefined = {};
  itemsPerPage?: number | undefined = 10;
  order?: string | undefined = '';
  pageNumber?: number = 1;
  sort?: boolean | undefined = false;
  page1?: boolean | undefined = false;
}